// React imports
// Store imports
// Ant design imports
import { Col, Row } from "antd"
import { Store } from "antd/lib/form/interface"
import { ForgotPasswordForm } from "Components/forms"
import React from "react"
// Model imports
// Shared modules imports
// Other imports
import { useTranslation } from "react-i18next"
// Redux imports
import { Link, useHistory, withRouter } from "react-router-dom"
import { AuthService } from "Shared/services"
import NotificationService, { NotificationTypeEnum } from "Shared/services/notification.service"
import AuthFooter from "./auth.footer"
import LoginLogo from "./login.logo"

const ForgotPassword: React.FC = () => {
    const history = useHistory()
    const { t } = useTranslation()

    const handleResetPassword = async ({ email }: Store) => {
        try {
            await AuthService.forgotPassword(email)
            NotificationService.send(NotificationTypeEnum.SUCCESS, t("notification:password_forgot.title"), t("notification:password_forgot.message"))

            history.push("/login")
        } catch (err) {
            NotificationService.showErrorNotificationBasedOnResponseError(err, "Error")
        }
    }

    const scrollTo = (ref: any) => {
        if (ref) {
            ref.scrollIntoView({ behavior: "smooth", block: "start" })
        }
    }

    return (
        <div className="login-bg flex flex-col items-center justify-center min-h-screen h-full w-full overflow-hidden relative">
            <Row className="w-full p-10 z-50 mb-40 my-auto" ref={scrollTo}>
                <Col span={24} className="max-w-400 min-w-300 my-0 mx-auto overflow-x-hidden overflow-y-hidden">
                    <LoginLogo />
                    <div className="bg-white w-full rounded-lg shadow mt-32 md:mt-40 pt-16">
                        <div className="pt-32 pl-32 pr-32">
                            <ForgotPasswordForm onSubmit={handleResetPassword} />
                        </div>
                        <div className="flex w-full flex-col items-center justify-center pb-32">
                            <Link className="finway-forgot-password finway-forgot-password-link" to="/login">
                                {t("nav:back_to_login")}
                            </Link>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className="w-full p-10 z-50 bottom-0 mb-0 sticky mt-auto">
                <Col span={24} className="max-w-450 min-w-300 my-0 mx-auto">
                    <AuthFooter />
                </Col>
            </Row>
        </div>
    )
}

export default withRouter(ForgotPassword)
